import { Component, inject } from '@angular/core';

import { Store } from '@ngxs/store';

import { UserLogOut } from '../../shared/state/app.actions';

@Component({
  selector: 'sh-auth-logout-page',
  template: ``,
  standalone: false
})
export class LogOutPageComponent {
  readonly #store = inject(Store);

  constructor() {
    this.#store.dispatch(new UserLogOut());
  }
}
